var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"education-details-modal","title":"Education Details","size":"lg","lazy":"","hide-footer":""}},[_c('EmployeeEducationDetailForm',{attrs:{"initial-form":{}},on:{"onSubmitClick":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }